import React, { useEffect } from 'react';
import { SeoBar } from '../components/SeoBar';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { HeroSection } from './breton/HeroSection';
import { CategoryCardsSection } from './breton/CategoryCardsSection';
import { AboutSection } from './breton/AboutSection';
import { GantryHeaderSection } from './breton/GantryHeaderSection';
import { MatrixE1Section } from './breton/MatrixE1Section';
import { MatrixE2Section } from './breton/MatrixE2Section';
import { MatrixE3Section } from './breton/MatrixE3Section';
import { FlymillSection } from './breton/FlymillSection';
import { EagleSection } from './breton/EagleSection';
import { HawxSection } from './breton/HawxSection';
import { UltrixSection } from './breton/UltrixSection';
export function BretonPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-1467">
      <SeoBar data-id="element-1468" />
      <Header data-id="element-1469" />
      <main className="flex-grow" data-id="element-1470">
        <div className="w-full bg-white pb-20" data-id="element-1471">
          <HeroSection data-id="element-1472" />
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 relative z-10" data-id="element-1473">
            <CategoryCardsSection data-id="element-1474" />
            <AboutSection data-id="element-1475" />
            <GantryHeaderSection data-id="element-1476" />
            <div className="space-y-12" data-id="element-1477">
              <MatrixE1Section data-id="element-1478" />
              <MatrixE2Section data-id="element-1479" />
              <MatrixE3Section data-id="element-1480" />
              <FlymillSection data-id="element-1481" />
              <EagleSection data-id="element-1482" />
              <HawxSection data-id="element-1483" />
              <UltrixSection data-id="element-1484" />
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-1485" />
    </div>;
}